<template>
  <div class="min-h-screen bg-gradient-to-br from-psychology-calm via-white to-psychology-warm">
    <!-- 顶部导航 -->
    <nav class="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-200">
      <div class="container mx-auto px-4 py-4">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-3">
            <router-link to="/" class="inline-flex items-center gap-2 px-3 py-2 hover:bg-gray-100 rounded-md transition-colors text-gray-600 hover:text-gray-900">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"></path>
                <path d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              </svg>
              首页
            </router-link>
            <div class="flex items-center gap-2">
              <span class="text-2xl">🦁</span>
              <span class="font-semibold text-psychology-primary">动物性格测试历史记录</span>
            </div>
          </div>
          <button @click="$router.push('/')" class="hidden sm:inline-flex items-center gap-2 px-3 py-2 border border-gray-300 bg-white hover:bg-gray-50 rounded-md transition-colors text-gray-600">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
              <path d="m12 19-7-7 7-7"></path>
              <path d="M19 12H5"></path>
            </svg>
            返回
          </button>
        </div>
      </div>
    </nav>

    <!-- 主要内容 -->
    <main class="container mx-auto px-4 py-8">
      <div class="max-w-6xl mx-auto">
      <div class="space-y-8">
        <!-- 统计卡片 -->
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <!-- 总测评次数 -->
          <div class="card">
            <div class="p-6">
              <div class="flex items-center justify-between">
                <div>
                  <p class="text-sm text-gray-600">总测试次数</p>
                  <p class="text-2xl font-bold text-psychology-primary">{{ totalCount }}</p>
                </div>
                <span class="text-4xl">📊</span>
              </div>
            </div>
          </div>

          <!-- 完成测评 -->
          <div class="card">
            <div class="p-6">
              <div class="flex items-center justify-between">
                <div>
                  <p class="text-sm text-gray-600">完成测试</p>
                  <p class="text-2xl font-bold text-psychology-success">{{ completedCount }}</p>
                  <p v-if="incompleteCount > 0" class="text-xs text-psychology-warning mt-1">
                    {{ incompleteCount }} 个进行中
                  </p>
                </div>
                <span class="text-4xl">✅</span>
              </div>
            </div>
          </div>

          <!-- 最常匹配的动物 -->
          <div class="card">
            <div class="p-6">
              <div class="flex items-center justify-between">
                <div>
                  <p class="text-sm text-gray-600">最常匹配</p>
                  <p class="text-xl font-bold text-psychology-accent flex items-center gap-2">
                    <span v-if="mostCommonAnimal">{{ mostCommonAnimal.emoji }}</span>
                    <span>{{ mostCommonAnimal?.name || '暂无' }}</span>
                  </p>
                  <p v-if="mostCommonAnimal" class="text-xs text-gray-500 mt-1">
                    {{ mostCommonAnimal.count }} 次
                  </p>
                </div>
                <span class="text-4xl">🏆</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 数据管理 -->
        <div class="card">
          <div class="p-6">
            <div class="text-2xl font-semibold flex items-center gap-2 mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" x2="12" y1="15" y2="3"></line>
              </svg>
              数据管理
            </div>
            <div class="flex flex-wrap gap-3">
              <button @click="exportJSON" class="btn-secondary flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                  <polyline points="7 10 12 15 17 10"></polyline>
                  <line x1="12" x2="12" y1="15" y2="3"></line>
                </svg>
                导出JSON
              </button>
              <button @click="exportCSV" class="btn-secondary flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                  <polyline points="7 10 12 15 17 10"></polyline>
                  <line x1="12" x2="12" y1="15" y2="3"></line>
                </svg>
                导出CSV
              </button>
              <button @click="confirmClearAll" class="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-md transition-colors flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                  <path d="M3 6h18"></path>
                  <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
                  <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
                  <line x1="10" x2="10" y1="11" y2="17"></line>
                  <line x1="14" x2="14" y1="11" y2="17"></line>
                </svg>
                清除所有记录
              </button>
            </div>
          </div>
        </div>

        <!-- 未完成测评记录 -->
        <div v-if="incompleteRecords.length > 0" class="space-y-4">
          <h2 class="text-xl font-semibold flex items-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-warning">
              <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"></path>
              <path d="M12 9v4"></path>
              <path d="M12 17h.01"></path>
            </svg>
            未完成测试
          </h2>

          <!-- 未完成记录卡片 -->
          <div 
            v-for="record in incompleteRecords" 
            :key="record.id"
            class="card hover:shadow-lg transition-shadow border-l-4 border-psychology-warning"
          >
            <div class="p-6">
              <div class="grid grid-cols-1 lg:grid-cols-4 gap-4">
                <!-- 基本信息 -->
                <div class="lg:col-span-2">
                  <div class="flex items-start justify-between mb-4">
                    <div>
                      <div class="flex items-center gap-2 mb-2">
                        <span class="px-2.5 py-0.5 text-xs font-semibold rounded-full text-psychology-warning border border-psychology-warning">
                          进行中
                        </span>
                      </div>
                      <p class="text-sm text-gray-600">{{ formatDate(record.timestamp) }}</p>
                      <p class="text-xs text-gray-500 mt-1">
                        进度：{{ record.progressInfo?.answeredCount || 0 }}/{{ record.progressInfo?.totalQuestions || 60 }} 题
                      </p>
                    </div>
                  </div>
                  <div class="text-sm text-gray-600 space-y-1">
                    <p v-if="record.basicInfo?.nickname">昵称：{{ record.basicInfo.nickname }}</p>
                    <p v-if="record.basicInfo?.gender">性别：{{ getGenderLabel(record.basicInfo.gender) }}</p>
                  </div>
                </div>

                <!-- 进度条 -->
                <div class="lg:col-span-1">
                  <div class="text-center">
                    <div class="mb-3">
                      <div class="text-2xl font-bold text-psychology-warning mb-1">
                        {{ record.progressInfo?.progress || 0 }}%
                      </div>
                      <div class="text-xs text-gray-600">完成进度</div>
                    </div>
                    <div class="w-full bg-gray-200 rounded-full h-2">
                      <div 
                        class="h-full bg-psychology-warning transition-all" 
                        :style="{ width: (record.progressInfo?.progress || 0) + '%' }"
                      ></div>
                    </div>
                  </div>
                </div>

                <!-- 操作按钮 -->
                <div class="lg:col-span-1">
                  <div class="flex flex-col gap-2">
                    <button
                      @click="continueAssessment(record)"
                      class="btn-primary bg-gradient-to-r from-psychology-primary to-psychology-secondary hover:shadow-lg flex items-center justify-center gap-2 text-sm"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                        <path d="M8 5v14l11-7z"></path>
                      </svg>
                      继续测试
                    </button>
                    <button 
                      @click="confirmDelete(record.id)" 
                      class="hover:bg-red-50 text-red-600 px-3 py-2 rounded-md transition-colors flex items-center justify-center gap-2 text-sm border border-transparent hover:border-red-200"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                        <path d="M3 6h18"></path>
                        <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
                        <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
                        <line x1="10" x2="10" y1="11" y2="17"></line>
                        <line x1="14" x2="14" y1="11" y2="17"></line>
                      </svg>
                      删除
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 已完成测评记录列表 -->
        <div class="space-y-4">
          <h2 class="text-xl font-semibold flex items-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
              <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
              <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
              <path d="M10 9H8"></path>
              <path d="M16 13H8"></path>
              <path d="M16 17H8"></path>
            </svg>
            已完成测试
          </h2>

          <!-- 空状态 -->
          <div v-if="records.length === 0 && incompleteRecords.length === 0" class="card p-12 text-center">
            <span class="text-6xl block mb-4">🦁</span>
            <h3 class="text-xl font-semibold text-gray-600 mb-2">暂无测试记录</h3>
            <p class="text-gray-500 mb-6">开始您的第一次测试，发现你的动物性格原型</p>
            <router-link to="/assessment/start" class="btn-primary bg-gradient-to-r from-psychology-primary to-psychology-secondary hover:shadow-lg inline-flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
              </svg>
              开始测试
            </router-link>
          </div>

          <!-- 记录卡片 -->
          <div 
            v-for="record in records" 
            :key="record.id"
            class="card hover:shadow-lg transition-shadow"
          >
            <div class="p-6">
              <div class="grid grid-cols-1 lg:grid-cols-4 gap-4">
                <!-- 基本信息 -->
                <div class="lg:col-span-2">
                  <div class="flex items-start justify-between mb-4">
                    <div>
                      <div class="flex items-center gap-2 mb-2">
                        <span class="px-2.5 py-0.5 text-xs font-semibold rounded-full text-psychology-success border border-psychology-success">
                          已完成
                        </span>
                      </div>
                      <p class="text-sm text-gray-600">{{ formatDate(record.timestamp) }}</p>
                      <p v-if="record.duration" class="text-xs text-gray-500 mt-1">用时：{{ record.duration }}</p>
                    </div>
                  </div>
                  <div class="text-sm text-gray-600 space-y-1">
                    <p v-if="record.basicInfo?.nickname">昵称：{{ record.basicInfo.nickname }}</p>
                    <p v-if="record.basicInfo?.gender">性别：{{ getGenderLabel(record.basicInfo.gender) }}</p>
                  </div>
                </div>

                <!-- 动物结果 -->
                <div class="lg:col-span-1">
                  <div class="text-center">
                    <div class="mb-3">
                      <div class="text-4xl mb-2">{{ record.emoji || '🦁' }}</div>
                      <div class="text-lg font-bold text-psychology-primary mb-1">
                        {{ record.animal || '未知' }}
                      </div>
                      <div class="text-xs text-gray-600">匹配度</div>
                    </div>
                    <div class="px-2.5 py-0.5 text-xs font-semibold rounded-full inline-block bg-psychology-primary/10 text-psychology-primary">
                      {{ getSimilarityPercent(record.similarity) }}%
                    </div>
                    <div class="mt-3">
                      <div class="relative w-full overflow-hidden rounded-full bg-gray-200 h-2">
                        <div 
                          class="h-full bg-psychology-primary transition-all" 
                          :style="{ width: getSimilarityPercent(record.similarity) + '%' }"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 操作按钮 -->
                <div class="lg:col-span-1">
                  <div class="flex flex-col gap-2">
                    <button
                      @click="viewResult(record)"
                      class="btn-primary bg-gradient-to-r from-psychology-primary to-psychology-secondary hover:shadow-lg flex items-center justify-center gap-2 text-sm"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                        <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path>
                        <circle cx="12" cy="12" r="3"></circle>
                      </svg>
                      查看结果
                    </button>
                    <button 
                      @click="confirmDelete(record.id)" 
                      class="hover:bg-red-50 text-red-600 px-3 py-2 rounded-md transition-colors flex items-center justify-center gap-2 text-sm border border-transparent hover:border-red-200"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                        <path d="M3 6h18"></path>
                        <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
                        <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
                        <line x1="10" x2="10" y1="11" y2="17"></line>
                        <line x1="14" x2="14" y1="11" y2="17"></line>
                      </svg>
                      删除
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </main>

    <!-- 回到顶部 -->
    <BackToTop />

    <!-- 删除确认对话框 -->
    <ConfirmDialog
      v-if="showDeleteDialog"
      title="确认删除"
      :message="deleteMessage"
      @confirm="handleDelete"
      @cancel="showDeleteDialog = false"
    />
  </div>
</template>

<script>
import BackToTop from '../components/BackToTop.vue'
import ConfirmDialog from '../components/ConfirmDialog.vue'
import { useToast } from 'vue-toastification'
import { 
  getCompletedSessions, 
  getIncompleteSessions, 
  deleteSession, 
  getAllSessions, 
  saveAllSessions,
  getSessionProgressInfo,
  cleanupExpiredSessions
} from '../utils/sessionStorage.js'
import { animalArchetypes } from '../data/animalArchetypes.js'

export default {
  name: 'HistoryPage',
  components: {
    BackToTop,
    ConfirmDialog
  },
  setup() {
    const toast = useToast()
    return { toast }
  },
  data() {
    return {
      records: [],
      incompleteRecords: [],
      showDeleteDialog: false,
      deleteMessage: '',
      deleteTarget: null,
      // 性别选项映射（动物测试版本）
      genderOptions: {
        'male': '男',
        'female': '女',
        'other': '其他',
        '': '未填写'
      }
    }
  },
  computed: {
    totalCount() {
      return this.records.length + this.incompleteRecords.length
    },
    completedCount() {
      return this.records.length
    },
    incompleteCount() {
      return this.incompleteRecords.length
    },
    // 计算最常匹配的动物
    mostCommonAnimal() {
      if (this.records.length === 0) return null
      
      const animalCounts = {}
      this.records.forEach(record => {
        if (record.animal) {
          if (!animalCounts[record.animal]) {
            animalCounts[record.animal] = {
              name: record.animal,
              emoji: record.emoji || animalArchetypes[record.animal]?.emoji || '🦁',
              count: 0
            }
          }
          animalCounts[record.animal].count++
        }
      })
      
      const animals = Object.values(animalCounts)
      if (animals.length === 0) return null
      
      // 按出现次数排序
      animals.sort((a, b) => b.count - a.count)
      return animals[0]
    }
  },
  mounted() {
    // 清理过期会话
    cleanupExpiredSessions()
    this.loadRecords()
  },
  methods: {
    // 过滤只显示动物测试会话
    filterAnimalSessions(sessions) {
      return sessions.filter(session => session.id && session.id.startsWith('animal_session_'))
    },
    
    // 性别标签
    getGenderLabel(gender) {
      if (!gender) return '未填写'
      return this.genderOptions[gender] || '未填写'
    },
    
    // 加载记录
    loadRecords() {
      try {
        // 从会话存储获取已完成会话
        const allCompletedSessions = getCompletedSessions()
        // 只显示动物测试会话
        const completedSessions = this.filterAnimalSessions(allCompletedSessions)
        
        // 转换为历史记录格式，并过滤掉没有答题的记录
        this.records = completedSessions
          .filter(session => {
            // 检查是否有答题数据
            const responses = session.responses || {}
            const answeredCount = Object.keys(responses).length
            return answeredCount > 0
          })
          .map(session => {
            const results = session.results || {}
            return {
              id: session.id,
              timestamp: session.timestamp,
              animal: results.animal || '未知',
              emoji: results.emoji || animalArchetypes[results.animal]?.emoji || '🦁',
              similarity: results.similarity || 0,
              basicInfo: session.demographics || {},
              endTime: session.endTime,
              duration: this.calculateDuration(session.startTime, session.endTime),
              ...results
            }
          })
        
        // 按时间倒序排序
        this.records.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
        
        // 加载未完成的会话
        const allIncompleteSessions = getIncompleteSessions()
        // 只显示动物测试会话
        const incompleteSessions = this.filterAnimalSessions(allIncompleteSessions)
        
        // 过滤掉没有答题的未完成记录
        this.incompleteRecords = incompleteSessions
          .map(session => {
            const progressInfo = getSessionProgressInfo(session.id)
            return {
              id: session.id,
              timestamp: session.timestamp,
              basicInfo: session.demographics || {},
              progressInfo: progressInfo,
              isIncomplete: true
            }
          })
          .filter(record => {
            // 检查是否有答题数据（至少答过1题）
            const answeredCount = record.progressInfo?.answeredCount || 0
            return answeredCount > 0
          })
        
        // 按时间倒序排序
        this.incompleteRecords.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
        
        console.log('加载历史记录成功:', this.records.length, '条已完成记录,', this.incompleteRecords.length, '条未完成记录')
      } catch (e) {
        console.error('加载历史记录失败:', e)
        this.toast.error('加载历史记录失败')
      }
    },
    
    // 计算测试用时
    calculateDuration(startTime, endTime) {
      if (!startTime || !endTime) return null
      try {
        const start = new Date(startTime)
        const end = new Date(endTime)
        const diff = Math.floor((end - start) / 1000) // 秒
        
        if (diff < 60) {
          return `${diff}秒`
        } else if (diff < 3600) {
          const minutes = Math.floor(diff / 60)
          const seconds = diff % 60
          return seconds > 0 ? `${minutes}分${seconds}秒` : `${minutes}分钟`
        } else {
          const hours = Math.floor(diff / 3600)
          const minutes = Math.floor((diff % 3600) / 60)
          return minutes > 0 ? `${hours}小时${minutes}分钟` : `${hours}小时`
        }
      } catch (e) {
        return null
      }
    },
    
    // 格式化日期
    formatDate(timestamp) {
      const date = new Date(timestamp)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${year}年${month}月${day}日 ${hours}:${minutes}`
    },
    
    // 将相似度转换为百分比（余弦相似度范围是-1到1，转换为0-100）
    getSimilarityPercent(similarity) {
      if (similarity === null || similarity === undefined) return 0
      // 将-1到1的范围映射到0-100
      const percent = Math.round(((similarity + 1) / 2) * 100)
      return Math.max(0, Math.min(100, percent))
    },
    
    // 查看结果
    viewResult(record) {
      this.$router.push({
        path: '/animal-result',
        query: { 
          sessionId: record.id
        }
      })
    },
    
    // 继续测试
    continueAssessment(record) {
      this.$router.push({
        path: '/assessment/questions',
        query: { 
          sessionId: record.id
        }
      })
    },
    
    // 确认删除
    confirmDelete(recordId) {
      this.deleteTarget = recordId
      this.deleteMessage = '确定要删除这条测试记录吗？删除后无法恢复。'
      this.showDeleteDialog = true
    },
    
    // 处理删除
    handleDelete() {
      if (this.deleteTarget === 'all') {
        // 清除所有会话记录（只清除动物测试的）
        const data = getAllSessions()
        // 只清除动物测试会话
        data.sessions = data.sessions.filter(s => !s.id || !s.id.startsWith('animal_session_'))
        saveAllSessions(data)
        this.records = []
        this.incompleteRecords = []
        this.toast.success('已清除所有记录')
      } else {
        // 删除单条会话记录
        deleteSession(this.deleteTarget)
        this.records = this.records.filter(r => r.id !== this.deleteTarget)
        this.incompleteRecords = this.incompleteRecords.filter(r => r.id !== this.deleteTarget)
        this.toast.success('已删除记录')
      }
      this.showDeleteDialog = false
      this.deleteTarget = null
    },
    
    // 确认清除所有
    confirmClearAll() {
      if (this.records.length === 0 && this.incompleteRecords.length === 0) {
        this.toast.warning('没有可清除的记录')
        return
      }
      this.deleteTarget = 'all'
      const total = this.records.length + this.incompleteRecords.length
      this.deleteMessage = `确定要清除所有 ${total} 条测试记录吗？此操作无法恢复！`
      this.showDeleteDialog = true
    },
    
    // 导出JSON
    exportJSON() {
      if (this.records.length === 0) {
        this.toast.warning('没有可导出的记录')
        return
      }
      try {
        const dataStr = JSON.stringify(this.records, null, 2)
        const blob = new Blob([dataStr], { type: 'application/json' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `动物性格测试历史记录_${new Date().toISOString().split('T')[0]}.json`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
        this.toast.success('JSON导出成功！')
      } catch (e) {
        console.error('导出失败:', e)
        this.toast.error('导出失败，请稍后重试')
      }
    },
    
    // 导出CSV
    exportCSV() {
      if (this.records.length === 0) {
        this.toast.warning('没有可导出的记录')
        return
      }
      try {
        // CSV表头
        const headers = ['日期', '动物', '相似度', '昵称', '性别']
        const csvRows = [headers.join(',')]
        
        // 数据行
        this.records.forEach(record => {
          const row = [
            this.formatDate(record.timestamp),
            record.animal || '未知',
            this.getSimilarityPercent(record.similarity) + '%',
            record.basicInfo?.nickname || '未填写',
            this.getGenderLabel(record.basicInfo?.gender)
          ]
          csvRows.push(row.join(','))
        })
        
        const csvStr = csvRows.join('\n')
        const BOM = '\uFEFF' // 添加BOM以支持中文
        const blob = new Blob([BOM + csvStr], { type: 'text/csv;charset=utf-8;' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `动物性格测试历史记录_${new Date().toISOString().split('T')[0]}.csv`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
        this.toast.success('CSV导出成功！')
      } catch (e) {
        console.error('导出失败:', e)
        this.toast.error('导出失败，请稍后重试')
      }
    }
  }
}
</script>
